var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.9,
    cx: 21,
    cy: 21,
    r: 21,
    className: "color5Fill"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 18.888C13.0004 19.1434 13.1105 19.3864 13.3028 19.5549L20.4268 25.7789C20.5894 25.9215 20.7983 26.0001 21.0145 26.0001C21.2308 26.0001 21.4397 25.9215 21.6024 25.7789L28.7263 19.5549C28.9492 19.341 29.045 19.0275 28.98 18.7261C28.9148 18.4246 28.6978 18.1782 28.4066 18.0754C28.1153 17.9724 27.7915 18.0276 27.5509 18.2211L21.0145 23.9295L14.4783 18.2211C14.3059 18.07 14.0816 17.9911 13.8525 18.0009C13.6233 18.0106 13.4067 18.1082 13.2478 18.2735C13.0889 18.4389 13.0001 18.659 13 18.888Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionOpen);
export default __webpack_public_path__ + "static/media/accordion-open.24470cb08038184a6817ae9a96ecd963.svg";
export { ForwardRef as ReactComponent };